import React from 'react'

export default function OrganizePages(props) {
  const { className } = props

  return (
    <div className={className ? className : ''}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="currentColor"
        viewBox="0 0 32 36"
      >
        <path
          fill="currentColor"
          fill-opacity=".1"
          d="M30.3 8.8V32c0 1.8-1.5 3.2-3.2 3.2H5c-1.8 0-3.2-1.5-3.2-3.2V4C1.8 2.2 3.2.7 5 .7h17.2c.5 0 1.1.2 1.4.6l6.1 6c.3.4.6.9.6 1.5Z"
          opacity=".1"
        />
        <path
          fill="currentColor"
          d="M30.2 6.8 23.8.6c-.3-.4-.9-.6-1.4-.6h-18C2.6 0 1 1.5 1 3.4v29.2C1 34.5 2.6 36 4.4 36h23.1c1.9 0 3.4-1.5 3.4-3.3V8.5c.1-.7-.2-1.3-.7-1.7Zm-.4 24.9c0 1.7-1.4 3.2-3.1 3.2H5.3c-1.7 0-3.1-1.4-3.1-3.2V4.3c0-1.7 1.4-3.2 3.1-3.2h16.5c.5 0 1 .2 1.4.6l5.9 5.8c.4.4.7 1 .6 1.6v22.6h.1Z"
        />
        <path
          fill="currentColor"
          fill-opacity=".1"
          d="M21.942 31.525H9.56a.578.578 0 0 1-.56-.593v-6.34c0-.296.224-.592.56-.592h12.382c.28 0 .56.237.56.593v6.34c0 .355-.224.592-.56.592Z"
        />
        <path
          fill="currentColor"
          d="M8.5 24.592c0-.512.392-1.092 1.06-1.092h12.382c.55 0 1.06.455 1.06 1.093v6.34c0 .283-.09.562-.29.773-.203.214-.48.32-.77.32H9.552l-.007-.002A1.078 1.078 0 0 1 8.5 30.92v-6.327Zm1 6.353a.079.079 0 0 0 .075.08h12.367a.11.11 0 0 0 .041-.005l.002-.001.001-.003.006-.012a.217.217 0 0 0 .01-.071v-6.34a.123.123 0 0 0-.008-.048.083.083 0 0 0-.041-.042c-.006-.003-.01-.003-.01-.003H9.56a.034.034 0 0 0-.015.003.052.052 0 0 0-.016.013.12.12 0 0 0-.03.076v6.353Z"
        />
        <path fill="#000" d="M11.25 26.26h9Zm0 3h9Z" />
        <path
          fill="currentColor"
          d="M20.25 28.76a.5.5 0 0 1 0 1h-9a.5.5 0 1 1 0-1h9Zm0-3a.5.5 0 0 1 0 1h-9a.5.5 0 1 1 0-1h9Z"
        />
        <path
          fill="currentColor"
          fill-opacity=".1"
          d="M21.942 12.525H9.56a.578.578 0 0 1-.56-.593v-6.34C9 5.297 9.224 5 9.56 5h12.382c.28 0 .56.237.56.593v6.34c0 .355-.224.592-.56.592Z"
        />
        <path
          fill="currentColor"
          d="M8.5 5.592c0-.51.391-1.092 1.06-1.092h12.382c.55 0 1.06.455 1.06 1.093v6.34c0 .283-.09.562-.29.773-.203.214-.48.32-.77.32H9.552l-.007-.002A1.078 1.078 0 0 1 8.5 11.92V5.592Zm1 6.353a.079.079 0 0 0 .075.08h12.367a.11.11 0 0 0 .041-.005l.002-.001.001-.003.006-.012a.217.217 0 0 0 .01-.071v-6.34a.123.123 0 0 0-.008-.048.084.084 0 0 0-.041-.042c-.006-.003-.01-.003-.01-.003H9.56c-.008 0-.012.002-.014.003a.05.05 0 0 0-.017.013.121.121 0 0 0-.03.076v6.353Z"
        />
        <path fill="#000" d="M11.25 7.26h9Zm0 3h9Z" />
        <path
          fill="currentColor"
          d="M20.25 9.76a.5.5 0 0 1 0 1h-9a.5.5 0 1 1 0-1h9Zm0-3a.5.5 0 0 1 0 1h-9a.5.5 0 1 1 0-1h9Z"
        />
        <path
          fill="#000"
          d="M16.143 16.658 13.57 15 11 16.658m2.57 3.131V15Zm7.43.553L18.43 22l-2.573-1.658m2.57-3.131V22Z"
        />
        <path
          fill="currentColor"
          d="M17.927 17.21a.5.5 0 0 1 1 0v3.874l1.803-1.162a.5.5 0 1 1 .54.84L18.7 22.42a.51.51 0 0 1-.074.038l-.013.005a.5.5 0 0 1-.077.024l-.017.003a.488.488 0 0 1-.092.009h-.006a.489.489 0 0 1-.161-.03.496.496 0 0 1-.124-.064l-2.55-1.642a.5.5 0 0 1 .542-.841l1.799 1.16V17.21Zm-4.857 2.58v-3.873l-1.798 1.161a.5.5 0 0 1-.543-.84l2.57-1.658a.5.5 0 0 1 .542 0l2.573 1.657a.5.5 0 0 1-.542.841l-1.802-1.161v3.872a.5.5 0 0 1-1 0Z"
        />
      </svg>
    </div>
  )
}
